<template>
    <div class="footer">
        <div class="container">
            <div class="left">
                <div class="brand">
                    <img class="logo" src="../assets/images/LOGO.png" alt="logo" />
                    <!-- <div>
                        <div>⻝品制造⾏业⼀站式服务平台</div>
                        <div>助⼒企业全产业链合规高效发展</div>
                    </div> -->
                </div>
                <div style="display: flex;gap:40px;margin-bottom: 40px;">
                    <div class="card">
                        <p style="margin-bottom: 20px;">地址：中国·浙江省宁波市高新区研发园C13幢（光华路299弄32号）</p>
                        <p>Add：Building C13，R&D Park，No. 32，Lane 299，Guanghua Road，High-tech Zone，Ningbo City，
                            Zhejiang Province，China</p>
                    </div>
                    <div class="card">
                        <div>官方热线：0574-87878989</div>
                        <div>邮箱：customer@nb.ccic.com</div>
<!--                        <div>纪检电话：0574-87022461</div>-->
<!--                        <div>信访邮箱：xinfang@nb.ccic.com</div>-->
<!--                        <div>举报邮箱：jubao@nb.ccic.com</div>-->
                    </div>
                    <div class="card">
                        <div class="qrs">
                            <div class="qr">
                                <div class="qr-img"><img src="../assets/images/qrcode_for_gh_d0458ec224f2_258.jpg" style="width: 100px;height: 100px;"></div>
                                <div class="qr-text">中检联</div>
                            </div>
                            <div class="qr" style="display: none;">
                                <div class="qr-img"></div>
                                <div class="qr-text">扫一扫关注</div>
                            </div>
                        </div>
                    </div>

                </div>
             
            </div>
            <!-- <div class="right">
                <div class="addr">浙江宁波市高新区研发园C13幢</div>
                <div class="phone">0574 - 87878989</div>
                <div class="email">customer@nb.ccic.com</div>
            </div> -->
            <!-- <div class="qrs">
                    <div class="qr">
                        <div class="qr-img"></div>
                        <div class="qr-text">扫一扫关注</div>
                    </div>
                    <div class="qr">
                        <div class="qr-img"></div>
                        <div class="qr-text">扫一扫关注</div>
                    </div>
                </div> -->
        </div>
        <div class="beian">COPYRIGHT © 2025-2026 中国检验认证集团宁波有限公司　<a href="https://beian.miit.gov.cn" target="_blank" style="color: white">浙ICP备12026784号-8</a></div>
    </div>
</template>

<script>
export default {
    data() {
        return {}
    },
    methods: {
        scrollToAnchor(anchorId) {
            // 如果当前在 product 页面，直接滚动到锚点
            if (this.$route.path === '/product') {
                const element = document.getElementById(anchorId)
                if (element) {
                    element.scrollIntoView({ behavior: 'smooth', block: 'start' })
                }
            } else {
                // 如果不在 product 页面，先跳转到 product 页面，然后滚动到锚点
                this.$router.push(`/product#${anchorId}`)
            }
        }
    },
}
</script>

<style scoped>
.footer {
    background: #2b3237;
    color: #fff;
    padding-bottom: 112px;
}

.container {
    /* display: flex; */
    border-bottom: 1px solid rgba(255, 255, 255, .2);
}

.card {
    width: 416px;
    background-color: #333b47;
    padding: 24px;
    line-height: 40px;
    font-size: 20px;
    font-weight: 500;
    color: rgba(255, 255, 255, 0.8);
}

.left {
    /* display: flex;
    justify-content: space-between;
    flex: 1; */
    border-right: 1px solid rgba(255, 255, 255, .2);
    padding: 102px 68px 0 296px;
}

.right {
    box-sizing: border-box;
    width: 632px;
    margin-top: 146px;
    margin-left: 61px;
    display: flex;
    flex-direction: column;
    /* align-items: flex-end; */
    padding-right: 296px;
    text-align: right;
}

.brand {
    margin-bottom: 40px;
    color: #cbd5e1;
    text-align: center;
}

.brand div {
    font-size: 28px;
    font-weight: 500;
    line-height: 54px;
    color: #fff;
}

.logo {
    display: block;
    /* margin: 0 auto; */
    width: 578px;
    /* height: 80px; */
    /* padding-bottom: 40px; */
}



.cols {
    display: flex;
    gap: 56px;
    /* border-top: 1px solid rgba(255, 255, 255, .2); */
    padding: 0px 96px 96px 0;
    white-space: nowrap;
}

.col {
    display: flex;
    flex-direction: column;
    gap: 36px;
}

.col-title {
    color: #e5e7eb;
    font-weight: 600;
    margin-bottom: 4px;
}

.link {
    color: #cbd5e1;
    text-decoration: none;
    font-size: 14px;
    opacity: .6
}

.link:hover {
    color: #fff
}

.addr {
    font-size: 20px;
    margin-bottom: 40px;
    white-space: nowrap;
}

.phone {
    font-size: 24px;
    font-weight: 500;
    color: #fff;
}

.email {
    margin: 40px 0 80px 0;
    font-size: 20px;
}

.qrs {
    display: flex;
    gap: 20px;
}

.qr {
    text-align: center;
}

.qr-img {
    width: 84px;
    height: 84px;
    background: #3b3838;
    border-radius: 4px;
}

.qr-text {
    margin-top: 8px;
    font-size: 12px;
    opacity: .8
}

.beian {
    text-align: center;
    color: rgba(255, 255, 255, 0.8);
    margin-top: 40px;
    font-size: 20px;
}
</style>